import React, { useContext, useRef } from 'react'
import { AppContext } from '../AppContext';
import { FontAwesome } from '../data/FontAwesome';
import { Audios, NaflAlarmSetting, AlarmAudios } from '../data/Audios'
import { Minutes } from '../data/Common';

export default function NaflAlarmForm() {

    const { naflAlarmSettings, updateSettings, t } = useContext(AppContext)

    const newNaflAlarm = useRef({})

    function saveNaflAlarm() {
        let nar = new NaflAlarmSetting(newNaflAlarm.current.id.value * 1, newNaflAlarm.current.minutes.value, newNaflAlarm.current.when.value, newNaflAlarm.current.vakit.value);
        let existingIndex = naflAlarmSettings.findIndex(f => f.minutes === nar.minutes && f.when === nar.when && f.vakit === nar.vakit)
        if (existingIndex >= 0) {
            naflAlarmSettings.splice(existingIndex, 1)
        }
        naflAlarmSettings.push({ ...nar });
        updateSettings({ naflAlarmSettings: naflAlarmSettings })
        document.activeElement.blur();
    }


    return (

        <div className='alarm-form-grid'>
            <label className='alarm-field alarm-field-wide'>
                <span>{t('alarms.sound')}</span>
                <select ref={(element) => newNaflAlarm.current.id = element} className='form-control form-control-sm'>
                    {AlarmAudios.map((q) => (<option key={'aaid' + q.id} value={q.id}>{q.name}</option>))}
                    {Audios.filter(f => !f.isAlarm).map((q) => (<option key={'aaid' + q.id} value={q.id}>{q.name}</option>))}
                </select>
            </label>
            <label className='alarm-field'>
                <span>{t('alarms.frequency')}</span>
                <div className='alarm-static-chip'>{t('alarms.everyday')}</div>
            </label>
            <label className='alarm-field'>
                <span>{t('alarms.minutes')}</span>
                <select ref={(element) => newNaflAlarm.current.minutes = element} className='form-control form-control-sm'>
                    {Minutes.map((each, index) => {
                        let tm = index + 1;
                        return (<option key={'minute' + tm} value={tm}>{tm} {t('alarms.minuteShort')}</option>)
                    })}
                </select>
            </label>
            <label className='alarm-field'>
                <span>{t('alarms.when')}</span>
                <select ref={(element) => newNaflAlarm.current.when = element} className='form-control form-control-sm'>
                    <option value='before'>{t('alarms.before')}</option>
                    <option value='after'>{t('alarms.after')}</option>
                </select>
            </label>
            <label className='alarm-field'>
                <span>{t('alarms.prayer')}</span>
                <select ref={(element) => newNaflAlarm.current.vakit = element} className='form-control form-control-sm'>
                    <option value='Fajr'>{t('prayers.Fajr')}</option>
                    <option value='Sunrise'>{t('prayers.Sunrise')}</option>
                    <option value='Dhuhr'>{t('prayers.Dhuhr')}</option>
                    <option value='Asr'>{t('prayers.Asr')}</option>
                    <option value='Maghrib'>{t('prayers.Maghrib')}</option>
                    <option value='Isha'>{t('prayers.Isha')}</option>
                    <option value='1/3 of Night'>{t('dashboard.lastThird')}</option>
                    <option value='Midnight'>{t('settings.midnight')}</option>
                    <option value='2/3 of Night'>{t('alarms.twoThirdsNight')}</option>
                </select>
            </label>
            <button onClick={saveNaflAlarm} className='alarm-submit'>{FontAwesome.Plus} {t('alarms.save')}</button>
        </div>

    )
}
